import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardDataServiceService {

private pendingCountSource = new BehaviorSubject<number>(0);

  pendingCount$ = this.pendingCountSource.asObservable();
  setPendingCount(count: number) {
    
  this.pendingCountSource.next(count);
  
  }
  
}
